export { StudentSettingsPage } from "./StudentSettingsPage"
export type { StudentSettingsPageProps } from "./StudentSettingsPage"
